<template>
    <div
        class="builder-sidebar-headline"
    >
        <slot></slot>
    </div>
</template>
